import React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: auto;
  height: 2.5rem;
  margin: 0.125rem 0;
`;
export default function Alerte() {
  return (
    <Wrapper className="!h-8 !w-auto" viewBox="0 0 52 44">
      <path
        d="M50.5076 37.0297L29.5198 2.22306C28.693 0.851849 27.1846 0 25.5834 0C23.9821 0 22.4738 0.851848 21.6468 2.22316L0.659117 37.0297C-0.195429 38.447 -0.220713 40.2226 0.59306 41.6637C1.40703 43.1048 2.94064 44 4.59557 44H46.5712C48.2261 44 49.7598 43.1048 50.5738 41.6636C51.3876 40.2224 51.3623 38.4468 50.5076 37.0297ZM47.6731 40.0256C47.449 40.4222 47.0268 40.6688 46.5712 40.6688H4.59557C4.13996 40.6688 3.71774 40.4223 3.49378 40.0257C3.26973 39.6289 3.27672 39.14 3.51187 38.75L24.4998 3.94335C24.7274 3.56589 25.1427 3.33134 25.5835 3.33134C26.0242 3.33134 26.4394 3.56589 26.6671 3.94335L47.6548 38.75C47.8901 39.1401 47.8971 39.6289 47.6731 40.0256Z"
        className="fill"
      />
      <path
        d="M25.5989 13.7061C24.3317 13.7061 23.3428 14.386 23.3428 15.5914C23.3428 19.2693 23.7754 24.5542 23.7754 28.2321C23.7755 29.1902 24.6101 29.592 25.599 29.592C26.3407 29.592 27.3916 29.1902 27.3916 28.2321C27.3916 24.5543 27.8242 19.2694 27.8242 15.5914C27.8242 14.3861 26.8043 13.7061 25.5989 13.7061Z"
        className="fill"
      />
      <path
        d="M25.6289 31.7236C24.2691 31.7236 23.249 32.8053 23.249 34.1035C23.249 35.3707 24.269 36.4834 25.6289 36.4834C26.8961 36.4834 27.9779 35.3707 27.9779 34.1035C27.9779 32.8053 26.896 31.7236 25.6289 31.7236Z"
        className="fill"
      />
    </Wrapper>
  );
}
